import { ClassificationMaps } from '@yourcause/common';
import { TypeaheadSelectOption } from '@yourcause/common/core-forms';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class ClassificationState extends BaseYcState {
  readonly classificationMap: ClassificationMaps;
  readonly classificationOptions: TypeaheadSelectOption[];
}
